<template>
  <div>
    <div
      v-if="isFilterShown"
      class="filter-active-container"
    >
      <div class="filter-active-header">
        <span class="font-semibold text-xl">Filter</span>
        <div class="ml-auto flex flex-row items-center">
          <vs-button
            type="border"
            color="primary"
            class="font-semibold"
            @click="resetFilter"
          >
            Reset
          </vs-button>
          <div
            class="close-button-container"
            @click="isFilterShown = false"
          >
            <vs-icon
              icon="close"
              color="#FF7F57"
              size="small"
            />
          </div>
        </div>
      </div>
      <div class="filter-active-body">
        <div class="filter-active-tabs">
          <div
            v-for="(item, index) of filterTabs"
            class="tab-body"
            :key="index"
            :class="{'bg-secondary': activeTab === item.value}"
            @click="activeTab = item.value"
          >
            <span
              class="mx-auto"
              :class="{'text-white font-semibold': activeTab === item.value}"
            >{{ item.text }}</span>
          </div>
        </div>
        <div v-if="activeTab === 1">
          <div class="flex-wrap tab-location-body">
            <div class="pr-1 mb-3 w-1/2 flex flex-col">
              <span class="mb-3 font-semibold">Tugboat</span>
              <select-with-search
                is-object-model
                class="select-with-search-bg-white"
                v-model="advanceFilter.search"
                :options="tugboats"
              />
            </div>
            <div class="pl-1 mb-3 w-1/2 flex flex-col">
              <span class="mb-3 font-semibold">Companies</span>
              <select-with-search
                is-object-model
                class="select-with-search-bg-white"
                v-model="advanceFilter.company_name"
                :options="companies"
              />
            </div>
            <div class="pr-1 mb-3 w-1/2 flex flex-col">
              <span class="mb-3 font-semibold">Date From</span>
              <date-picker
                v-model="advanceFilter.start_date"
                type="date"
                format="DD-MMM-YYYY"
                class="datepicker-with-bg-white"
                placeholder="dd-mmm-yyyy"
              />
            </div>
            <div class="pl-1 mb-3 w-1/2 flex flex-col">
              <span class="mb-3 font-semibold">Date To</span>
              <date-picker
                v-model="advanceFilter.end_date"
                type="date"
                format="DD-MMM-YYYY"
                class="datepicker-with-bg-white"
                placeholder="dd-mmm-yyyy"
              />
            </div>
            <div class="pr-1 mb-3 w-1/2 flex flex-col">
              <span class="mb-3 font-semibold">Barge Status</span>
              <select-with-search
                is-object-model
                v-model="advanceFilter.barge_status"
                class="select-with-search-bg-white"
                :options="bargeStatuses"
              />
            </div>
            <div class="pl-1 mb-3 w-1/2 flex flex-col">
              <span class="mb-3 font-semibold">ETA</span>
              <date-picker
                v-model="advanceFilter.eta_date"
                type="date"
                format="DD-MMM-YYYY"
                class="datepicker-with-bg-white"
                placeholder="dd-mmm-yyyy"
              />
            </div>
            <div class="pr-1 w-1/2 flex flex-col">
              <span class="mb-3 font-semibold">Port</span>
              <select-with-search
                is-object-model
                v-model="advanceFilter.port"
                class="select-with-search-bg-white"
                :options="ports"
              />
            </div>
          </div>
        </div>
        <div
          v-else
          class="tab-location-body"
        >
          <div class="mr-1 w-full flex flex-col">
            <span class="mb-3 font-semibold">Barge Status</span>
            <select-with-search
              is-object-model
              v-model="locationFilter.barge_status"
              class="select-with-search-bg-white"
              :options="bargeStatuses"
            />
          </div>
          <div class="ml-1 w-full flex flex-col">
            <span class="mb-3 font-semibold">Location</span>
            <select-with-search
              is-object-model
              v-model="locationFilter.barge_location"
              class="select-with-search-bg-white"
              :options="locations"
            />
          </div>
        </div>
      </div>
      <div class="filter-active-footer">
        <div>
          <vs-button
            type="filled"
            color="secondary"
            class="w-32 font-semibold"
            @click="filterByTabs(activeTab === 1 ? 'advance' : 'location')"
          >
            Search
          </vs-button>
        </div>
        <div
          v-if="activeTab === 1"
          class="ml-2"
        >
          <vs-button
            type="filled"
            color="secondary"
            class="w-32 font-semibold"
            @click="showTrip"
          >
            Show Trip
          </vs-button>
        </div>
        <img
          :src="require('../../assets/shipo-sales-plan-icon-excel.svg')"
          class="ml-2 h-12 self-center cursor-pointer bg-white rounded-xl shadow"
          @click="downloadExcel(activeTab === 1 ? 'advance' : 'location')"
        >
      </div>
    </div>
    <div
      v-else
      class="filter-inactive-container"
      @click="isFilterShown = true"
    >
      <vs-icon
        icon="search"
        color="primary"
      />
      <span class="mx-5 text-grey-001">Search here...</span>
      <vs-icon
        icon="arrow_drop_down"
        color="primary"
        class="ml-auto cursor-pointer icon-transparent-bg"
      />
    </div>
  </div>
</template>

<script>
import DatePicker from '@/components/datePicker'
import SelectWithSearch from '@/components/selectWithSearch'
import { FILTER_LAST_POSITION, FILTER_TRIP } from '@/fixtures/Constants'

export default {
  props: {
    tugboats: {
      type: Array,
      default: () => []
    },
    companies: {
      type: Array,
      default: () => []
    },
    bargeStatuses: {
      type: Array,
      default: () => []
    },
    locations: {
      type: Array,
      default: () => []
    },
    ports: {
      type: Array,
      default: () => []
    }
  },
  components: {
    DatePicker,
    SelectWithSearch
  },
  data() {
    return {
      isFilterShown: false,
      activeTab: 1,
      filterTabs: [
        { value: 1, text: 'Advanced' },
        { value: 2, text: 'Location' }
      ],
      searchState: FILTER_LAST_POSITION,
      advanceFilter: {
        search: null,
        company_name: null,
        start_date: null,
        end_date: null,
        barge_status: null,
        eta_date: null,
        port: null
      },
      locationFilter: {
        barge_status: null,
        barge_location: null
      }
    }
  },
  methods: {
    getFilterText(data) {
      if (data) {
        return data.text
      }

      return data
    },
    resetFilter() {
      this.advanceFilter = {
        search: null,
        company_name: null,
        start_date: null,
        end_date: null,
        barge_status: null,
        eta_date: null,
        port: null
      }

      this.locationFilter = {
        barge_status: null,
        barge_location: null
      }

      this.$emit('reset', { filters: null, type: FILTER_LAST_POSITION })
    },
    getAdvanceFilter() {
      let filter = {}
      Object.keys(this.advanceFilter).forEach(key => {
        filter = {
          ...filter,
          [key]: key.includes('date')
            ? this.advanceFilter[key]
            : this.getFilterText(this.advanceFilter[key])
        }
      })
      return filter
    },
    filterByTabs(filterType) {
      this.$emit('reset-selected-vessel')
      if (filterType === 'advance') {
        this.searchState = FILTER_LAST_POSITION
        this.$emit('advance-filter', {
          type: FILTER_LAST_POSITION,
          filters: this.getAdvanceFilter()
        })
        return
      }

      let filter = {}
      Object.keys(this.locationFilter).forEach(key => {
        filter = {
          ...filter,
          [key]: this.getFilterText(this.locationFilter[key])
        }
      })
      this.$emit('location-filter', {
        filters: filter
      })
    },
    showTrip() {
      this.$emit('reset-selected-vessel')
      this.searchState = FILTER_TRIP
      const {
        company_name,
        search,
        start_date,
        end_date
      } = this.getAdvanceFilter()
      this.$emit('show-trip', {
        type: FILTER_TRIP,
        filters: {
          company_name,
          tugboat_name: search,
          start_date,
          end_date
        }
      })
    },
    downloadExcel(filterType) {
      if (filterType === 'advance') {
        let downloadFilters = this.getAdvanceFilter()
        const {
          company_name,
          search,
          start_date,
          end_date
        } = this.getAdvanceFilter()
        if (this.searchState === FILTER_TRIP) {
          downloadFilters = {
            company_name,
            tugboat_name: search,
            start_date,
            end_date
          }
        }
        this.$emit('download', downloadFilters)
        return
      }

      let filter = {}
      Object.keys(this.locationFilter).forEach(key => {
        filter = {
          ...filter,
          [key]: this.getFilterText(this.locationFilter[key])
        }
      })

      this.$emit('download', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-inactive-container {
  @apply p-2 flex flex-row items-center bg-white rounded-lg;

  min-width: 20rem;
}

.filter-active-container {
  @apply flex flex-col rounded-lg;

  background-color: #F1F1FD;
  max-width: 25rem;
}

.filter-active-header {
  @apply p-2 px-3 flex flex-row items-center bg-white rounded-lg;
}

.filter-active-body {
  @apply mt-5 p-2 px-3 flex flex-col;
}

.filter-active-tabs {
  @apply mb-5 flex flex-row bg-white rounded-lg;
}

.filter-active-footer {
  @apply py-5 px-3 flex flex-row items-center justify-end;
}

.tab-body {
  @apply m-2 p-3 w-1/2 flex flex-row items-center cursor-pointer rounded-lg;
}

.tab-location-body {
  @apply w-full flex flex-row;
}

.icon-transparent-bg {
  background-color: #C2B6EA;
  border-radius: 0.5rem;
}

.close-button-container {
  @extend .icon-transparent-bg;
  @apply p-1 ml-5 flex flex-row items-center cursor-pointer;
}

.select-with-search-bg-white {
  /deep/.bg-accent-multiselect {
    @apply bg-white;
  }
}

.datepicker-with-bg-white {
  @apply w-full #{!important};

  /deep/.mx-input-wrapper {
    background-color: white;
  }
}
</style>
